<app-loader [loading]="!centersLoaded" [fullPage]="true" [title]="'chargement'"></app-loader>
<section *ngIf="centersLoaded" class="simulation grid-container grid-container--section no-gutter-mobile" data-overload-controller="AdhesionPegaseCtrl">
    <app-stepper-component [currentStepId]="'etude_dossier'"></app-stepper-component>
    <div>
        <form method="POST" novalidate="" enctype="multipart/form-data">
            <fieldset class="simulation__step" data-ng-form="adhesionForm" name="adhesionForm">
                <legend style="display: none">detail disponibilite cabinet</legend>
                <div data-ui-view="adhesionSteps">
                    <section class="appointment grid-12 no-gutter">
                        <div class="simulation__group">
                            <div cand-scroll-error="" data-ui-view="appointmentStep" autoscroll="false">
                                <section class="appointment-details ng-scope">
                                    <div class="simulation__group grid-container">
                                        <div class="appointment-details__header grid-12">
                                            <div class="appointment-details__header-back grid-1">
                                                <button type="button" class="appointment-details__header-back__button" routerLink="/souscription/appointment/appointment-planner">
                                                    <img alt="back" [appAssetSrc]="'assets/images/icon-arrow-left.png'" />
                                                </button>
                                            </div>
                                            <div class="appointment-details__header-title grid-11">
                                                <span class="grid-10 no-gutter">
                                                    <div>{{ informationPraticien.libelleCentre }}</div>
                                                    <div class="appointment-details__header-title--light">
                                                        {{ informationPraticien.adresse1 }},
                                                        <div class="appointment-details__header-title--light--city">{{ informationPraticien.codePostal }} {{ informationPraticien.ville }}</div>
                                                    </div>
                                                </span>
                                                <div class="appointment-details__header-icon grid-2 grid-mobile-4">
                                                    <img alt="ARM Logo" [appAssetSrc]="'assets/images/logo-ARM.svg'" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="appointment-details__body grid-7 grid-mobile-4 centered">
                                            <button class="appointment-details__body__changecenter button" routerLink="/souscription/appointment/appointment-planner">
                                                {{ 'appointment.appointment-details.changecenter' | i18n }}
                                            </button>
                                            <div class="appointment-details__body__duration-information">
                                                <span [innerHTML]="'appointment.appointment-details.durationinformation' | i18n"></span>
                                            </div>
                                            <div class="appointment-details__body__accordions">
                                                <div *ngFor="let item of contentRdvMedical.slice(0, limitedDate); let index = index" [ngClass]="{ active: dateRDVIsOpen(item.id), default: !dateRDVIsOpen(item.id) }" class="pegase-accordion">
                                                    <div class="pegase-accordion__header" (click)="selectItem(item.id)">
                                                        <span>{{ formatDate(item.dateDebut) }}</span>
                                                        <span class="pegase-accordion__header--icon" [ngClass]="{ active: dateRDVIsOpen(item.id), default: !dateRDVIsOpen(item.id) }">
                                                            <img *ngIf="!dateRDVIsOpen(item.id)" alt="" [appAssetSrc]="'assets/images/chevron-green-down.svg'" />
                                                        </span>
                                                    </div>
                                                    <div *ngIf="dateRDVIsOpen(item.id)" class="pegase-accordion__body" [ngClass]="{ active: dateRDVIsOpen(item.id), default: !dateRDVIsOpen(item.id) }">
                                                        <div class="pegase-accordion__body__hours">
                                                            <div
                                                                class="pegase-accordion__body__hours__hour"
                                                                *ngFor="let element of getLimitedTimes(item.rdvByDateDebut, item.limitedHoursToShow)"
                                                                (click)="selectHours(element)"
                                                                [ngClass]="{ active: currentHoursSelected === element.dateDebut }"
                                                                data-ng-repeat="time in appointmentDetails.getLimitedTimes(accordionVM)"
                                                            >
                                                                {{ formatHour(element.dateDebut) }}
                                                            </div>
                                                        </div>
                                                        <div *ngIf="!item.showAllItems" (click)="showUnlimitedHours(index)" class="appointment-details__link margin-bottom">
                                                            {{ 'appointment.appointment-details.appointments.seemore' | i18n }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div *ngIf="linkShowMore" (click)="showUnlimitedRdv()" class="appointment-details__link gutter-bottom">
                                                {{ 'appointment.appointment-details.appointments.moredisponibilities' | i18n }}
                                            </div>
                                            <span class="appointment-details__link--info">
                                                <span>{{ 'appointment.appointment-details.callarm' | i18n }}</span>
                                                <u [appTagCommander]="'tagCo.appointment.appointmentdetails.webcallback.button'" (click)="callARM()">{{ 'appointment.appointment-details.callarm.link' | i18n }}</u>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="appointment-details__footer simulation__buttons simulation__buttons--light">
                                        <div class="appointment-details__footer__back">
                                            <button type="button" class="button button--grey button--previous" routerLink="/souscription/document-medicale/document-list">
                                                {{ 'global.button.return-to-list' | i18n }}
                                            </button>
                                        </div>
                                        <button type="button" [disabled]="!currentHoursSelected" (click)="goToAppointmentTimeTable()" class="appointment-details__footer__next button button--primary button--next" disabled="disabled">
                                            {{ 'global.button.confirm' | i18n }}
                                        </button>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </section>
                </div>
            </fieldset>
        </form>
    </div>
</section>
<app-validation-modal-component
    [modalTitle]="'appointment.appointment-details.popin.edit.title' | i18n"
    [content]="currentRDVToEdit"
    [visibility]="showModalModification"
    [buttonRight]="'global.yesedit'"
    [specificIconBlock]="'modal-info-red'"
    (leftClick)="closeModal()"
    (rightClick)="confirmModal()"
    (crossClick)="closeModal()"
>
</app-validation-modal-component>

<app-validation-modal-component
    [modalTitle]="'appointment.appointment-details.popin.choosehour.title' | i18n"
    [content]="contentWebCallBack"
    [visibility]="showModalWebCallBack"
    (leftClick)="closeWebCallBackModal()"
    (rightClick)="confirmWebCallBackModal()"
    (crossClick)="closeWebCallBackModal()"
>
</app-validation-modal-component>
